import { useState, useEffect } from "react";
import UserPic from "../assets/images/userPic.png";
import {
  useNavigate,
  Link as RouterLink,
  useParams,
  useLocation,
} from "react-router-dom";
import { Navbar, Page, Loader } from "../components";
import { getOrderHistory, getAllOrganisations, getSetOrderHistory } from "../assets/Js/script";
import * as ROUTES from "../constant/routes";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import OrderHistoryHeader from "../components/OrderHistoryHeader";


export default function OrgOrderHistory() {
  const [orders, setOrders] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [ordersSet, setordersSet] = useState([])
  const navigate = useNavigate();
  const { state } = useLocation();
  const notify = (message) => toast(message);

  const params = useParams();

  useEffect(() => {
    (async () => {
      setIsLoading(false);
      const { response, error } = await getOrderHistory(
        "organisationId",
        params.order_id.split("=")[1]
      );
      if (response.status === "success") {
        setOrders(response.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        notify(response?.message ? response?.message : "Something went wrong");
      }
    })();
    getSetOrderIds()
  }, [params.order_id]);


  const getSetOrderIds = async () => {
    const { response, error } = await getSetOrderHistory(
      "organisationId",
      params.order_id.split("=")[1]
    );
    if (response.status === "success") {
      setordersSet(response.data);
      console.log(response, 'set response')
      // setIsLoading(false);
    } else {
      // setIsLoading(false);
      console.log(response?.message)
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }


  const [idData, setIdData] = useState([]);

  function filterData(bookid) {
    const idValue = bookid;
    const test = [];
    //   // const parValue = params.order_details.split("=")[1];

    if (orders) {
      for (var i = 0; i < orders?.bookData?.length; i++) {
        for (var x = 0; x < orders?.orderIdGroup[bookid].length; x++) {
          if (
            orders?.bookData[i]?.id === orders?.orderIdGroup[bookid][x]?.bookId
          ) {
            test.push(orders?.bookData[i]);
            continue;
          } else console.log("not matching!");
        }
      }
    }
    // setIdData([...test]);
  }

  // Detail------------

  const [organisation, setOrganisation] = useState(null);
  const [detail, setDetail] = useState([]);

  useEffect(() => {
    const organisation = async () => {
      const {
        response: { data, status },
      } = await getAllOrganisations();
      if (status === "success") {
        const id = params.order_id.split("=")[1];
        let value = data?.pcpDetail?.filter((elem, index) => {
          return elem.organisationId === id;
        });
        let value2 = data?.publication?.Organisations?.filter((elem, index) => {
          return elem.id === id;
        });
        setOrganisation({ ...value2[0] });
        setDetail({ ...value[0] });
      }
    };
    organisation();
  }, []);

  function filterData(bookid) {
    const test = [];
    const id = params.order_id.split("=")[1];

    if (orders) {
      for (var i = 0; i < orders?.bookData?.length; i++) {
        for (var x = 0; x < orders?.orderIdGroup[bookid].length; x++) {
          if (
            orders?.bookData[i]?.parentId ===
            orders?.orderIdGroup[bookid][x]?.bookId
          ) {
            test.push(orders?.bookData[i]);
          } else console.log("not working!");
        }
      }
    }

    return test;
  }


  function getDate(id, type) {
    if (type == 'set') {
      return ordersSet.orderIdGroup[id][0].createdAt;
    } else {
      return orders.orderIdGroup[id][0].createdAt;

    }
  }
  function filterDataForSet(bookid) {

    const test = [];
    const id = params.order_id.split("=")[1];
    if (ordersSet) {
      for (var i = 0; i < ordersSet?.setData?.length; i++) {
        for (var x = 0; x < ordersSet?.orderIdGroup[bookid].length; x++) {
          if (
            ordersSet?.setData[i]?.id ===
            ordersSet?.orderIdGroup[bookid][x]?.setId
          ) {
            test.push(ordersSet?.setData[i]);
          } else console.log("not working!");
        }
      }
    }
    return test;
  }
  return (
    <Page>
      <Navbar />
      {isLoading ? (
        <Loader show={isLoading} />
      ) : (
        <>
          <OrderHistoryHeader />
          <div
            className={`my-14 mt-8 block lg:hidden px-4 flex lg:hidden justify-between items-center w-screen `}
          >
            <h1 className=" flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
              <span onClick={() => navigate(-1)} className=" mr-3">
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                    fill="#702963"
                  />
                </svg>
              </span>
              Order History
            </h1>
            <div className="flex lg:hidden items-center">
              <button className="mr-5">
                <svg
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                    stroke="#702963"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button>
                <svg
                  width="28"
                  height="24"
                  viewBox="0 0 28 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                    fill="#702963"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between lg:w-full">
            <div className="flex  flex-col gap-y-5">
              <div className="flex  flex-col justify-evenly items-center bg-primary-white lg:bg-primary-extra-light border-primary-dark-20 lg:border-1 border-solid w-263 lg:h-205 lg:mr-4 mx-auto lg:mx-0">
                <p className="text-[14px] lg:text-p1 text-secondary-light mb-3 lg:mb-0">
                  Organization Name
                </p>
                <div
                  className={`bg-[#bb7aaf] flex justify-center items-center w-24 h-24 rounded-full`}
                >
                  {organisation?.organisationPhoto ? (
                    <img src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/portals/${organisation?.organisationPhoto}`} alt="img" />
                  ) : (
                    <span
                      className={`text-[50px] uppercase font-bold text-[#fff]`}
                    >
                      {organisation?.brandName[0]}
                    </span>
                  )}
                </div>{" "}
                <h2 className="text-p1 capitalize mt-3 lg:mt-0 lg:text-h2 text-heading font-semibold">
                  {organisation?.brandName}
                </h2>
                <RouterLink
                  to="organization-details"
                  className="mt-2 lg:hidden leading-[19px] text-p1 text-tertiary-dark underline font-semibold text-center"
                >
                  View details
                </RouterLink>
              </div>
              <div className=" hidden lg:flex pl-8 flex-col py-4  items-start bg-primary-extra-light border-primary-dark-20 border-1 border-solid w-263  mr-4">
                <div className="flex mb-6 ml-1">
                  <svg
                    style={{ marginTop: "6px" }}
                    width="17"
                    height="13"
                    viewBox="0 0 17 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.8455 3.46857C16.895 3.51792 16.9343 3.57655 16.9611 3.64109C16.9878 3.70563 17.0016 3.77482 17.0016 3.8447C17.0016 3.91458 16.9878 3.98377 16.9611 4.04831C16.9343 4.11285 16.895 4.17148 16.8455 4.22082L13.658 7.40833C13.6087 7.4578 13.5501 7.49705 13.4855 7.52383C13.421 7.55061 13.3518 7.5644 13.2819 7.5644C13.212 7.5644 13.1429 7.55061 13.0783 7.52383C13.0138 7.49705 12.9551 7.4578 12.9058 7.40833L11.312 5.81458C11.2123 5.71482 11.1562 5.57952 11.1562 5.43845C11.1563 5.29738 11.2123 5.16208 11.312 5.06232C11.4118 4.96257 11.5471 4.90653 11.6882 4.90653C11.8292 4.90653 11.9645 4.96257 12.0643 5.06232L13.2819 6.28101L16.0933 3.46857C16.1426 3.4191 16.2013 3.37985 16.2658 3.35307C16.3304 3.32629 16.3995 3.3125 16.4694 3.3125C16.5393 3.3125 16.6085 3.32629 16.673 3.35307C16.7376 3.37985 16.7962 3.4191 16.8455 3.46857Z"
                      fill="#7D7C7C"
                    />
                    <path
                      d="M1.0625 12.875C1.0625 12.875 0 12.875 0 11.8125C0 10.75 1.0625 7.5625 6.375 7.5625C11.6875 7.5625 12.75 10.75 12.75 11.8125C12.75 12.875 11.6875 12.875 11.6875 12.875H1.0625ZM6.375 6.5C7.22038 6.5 8.03113 6.16418 8.6289 5.5664C9.22668 4.96863 9.5625 4.15788 9.5625 3.3125C9.5625 2.46712 9.22668 1.65637 8.6289 1.0586C8.03113 0.460825 7.22038 0.125 6.375 0.125C5.52962 0.125 4.71887 0.460825 4.1211 1.0586C3.52332 1.65637 3.1875 2.46712 3.1875 3.3125C3.1875 4.15788 3.52332 4.96863 4.1211 5.5664C4.71887 6.16418 5.52962 6.5 6.375 6.5Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Registered name</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {organisation?.registeredName}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "3px" }}
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.59338 3.66699C4.92532 3.66699 4.28463 3.92222 3.81224 4.37653C3.33985 4.83084 3.07446 5.44702 3.07446 6.08951V6.33298L10.6312 10.2466L18.188 6.33419V6.08951C18.188 5.44702 17.9226 4.83084 17.4502 4.37653C16.9778 3.92222 16.3371 3.66699 15.6691 3.66699H5.59338Z"
                      fill="#7D7C7C"
                    />
                    <path
                      d="M18.188 7.70898L10.9297 11.4675C10.838 11.515 10.7354 11.5399 10.6312 11.5399C10.527 11.5399 10.4245 11.515 10.3327 11.4675L3.07446 7.70898V13.3571C3.07446 13.9996 3.33985 14.6158 3.81224 15.0701C4.28463 15.5244 4.92532 15.7796 5.59338 15.7796H15.6691C16.3371 15.7796 16.9778 15.5244 17.4502 15.0701C17.9226 14.6158 18.188 13.9996 18.188 13.3571V7.70898Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Email address</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {detail?.email}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "3px" }}
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3823 15.3398L13.1317 12.206C12.978 12.0579 12.7761 11.9789 12.5685 11.9857C12.361 11.9925 12.1641 12.0846 12.0193 12.2424L10.1058 14.3291C9.64515 14.2358 8.71915 13.9297 7.76596 12.9216C6.81277 11.9101 6.52409 10.9257 6.43853 10.4407L8.40489 8.41086C8.55395 8.2575 8.64089 8.04866 8.64731 7.82854C8.65373 7.60841 8.57912 7.39428 8.43927 7.23145L5.48454 3.78566C5.34463 3.62232 5.15019 3.52324 4.94249 3.50947C4.7348 3.49569 4.53023 3.56831 4.37222 3.71189L2.63696 5.2898C2.49871 5.43692 2.41619 5.63273 2.40506 5.84008C2.39307 6.05205 2.16436 11.0732 5.83639 14.9684C9.03981 18.3641 13.0525 18.6126 14.1576 18.6126C14.3192 18.6126 14.4183 18.6075 14.4447 18.6058C14.6402 18.5942 14.8248 18.5063 14.9629 18.3591L16.4502 16.5183C16.5862 16.3513 16.6552 16.1346 16.6425 15.9144C16.6298 15.6942 16.5364 15.4879 16.3823 15.3398Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Phone number</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      +91 {detail?.mobile}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6 ml-1">
                  <svg
                    style={{ marginTop: "5px" }}
                    width="13"
                    height="17"
                    viewBox="0 0 13 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.83346 1.03016C1.60017 1.03016 1.37644 1.11524 1.21148 1.26668C1.04652 1.41811 0.953842 1.62351 0.953842 1.83767V13.1428C0.953842 13.3569 1.04652 13.5623 1.21148 13.7138C1.37644 13.8652 1.60017 13.9503 1.83346 13.9503H6.67139V14.7578H1.83346C1.36688 14.7578 0.919412 14.5876 0.58949 14.2847C0.259567 13.9819 0.0742188 13.5711 0.0742188 13.1428V1.83767C0.0742188 1.40934 0.259567 0.998556 0.58949 0.695682C0.919412 0.392809 1.36688 0.222656 1.83346 0.222656H10.6297C11.0963 0.222656 11.5437 0.392809 11.8737 0.695682C12.2036 0.998556 12.3889 1.40934 12.3889 1.83767V13.1428C12.3889 13.5711 12.2036 13.9819 11.8737 14.2847C11.5437 14.5876 11.0963 14.7578 10.6297 14.7578H9.31026V13.9503H10.6297C10.863 13.9503 11.0867 13.8652 11.2517 13.7138C11.4166 13.5623 11.5093 13.3569 11.5093 13.1428V1.83767C11.5093 1.62351 11.4166 1.41811 11.2517 1.26668C11.0867 1.11524 10.863 1.03016 10.6297 1.03016H1.83346Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.5918 3.04828C3.5918 2.9412 3.63813 2.83851 3.72061 2.76279C3.8031 2.68707 3.91496 2.64453 4.03161 2.64453H8.42972C8.54637 2.64453 8.65824 2.68707 8.74072 2.76279C8.8232 2.83851 8.86954 2.9412 8.86954 3.04828C8.86954 3.15537 8.8232 3.25806 8.74072 3.33378C8.65824 3.4095 8.54637 3.45204 8.42972 3.45204H4.03161C3.91496 3.45204 3.8031 3.4095 3.72061 3.33378C3.63813 3.25806 3.5918 3.15537 3.5918 3.04828Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.83398 5.47016C1.83398 5.36308 1.88032 5.26038 1.9628 5.18466C2.04528 5.10894 2.15715 5.06641 2.2738 5.06641H10.1904C10.307 5.06641 10.4189 5.10894 10.5014 5.18466C10.5839 5.26038 10.6302 5.36308 10.6302 5.47016C10.6302 5.57724 10.5839 5.67994 10.5014 5.75565C10.4189 5.83137 10.307 5.87391 10.1904 5.87391H2.2738C2.15715 5.87391 2.04528 5.83137 1.9628 5.75565C1.88032 5.67994 1.83398 5.57724 1.83398 5.47016Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.83398 7.08735C1.83398 6.98026 1.88032 6.87757 1.9628 6.80185C2.04528 6.72613 2.15715 6.68359 2.2738 6.68359H10.1904C10.307 6.68359 10.4189 6.72613 10.5014 6.80185C10.5839 6.87757 10.6302 6.98026 10.6302 7.08735C10.6302 7.19443 10.5839 7.29713 10.5014 7.37284C10.4189 7.44856 10.307 7.4911 10.1904 7.4911H2.2738C2.15715 7.4911 2.04528 7.44856 1.9628 7.37284C1.88032 7.29713 1.83398 7.19443 1.83398 7.08735Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.83398 8.70063C1.83398 8.59355 1.88032 8.49085 1.9628 8.41513C2.04528 8.33941 2.15715 8.29688 2.2738 8.29688H10.1904C10.307 8.29688 10.4189 8.33941 10.5014 8.41513C10.5839 8.49085 10.6302 8.59355 10.6302 8.70063C10.6302 8.80771 10.5839 8.91041 10.5014 8.98613C10.4189 9.06184 10.307 9.10438 10.1904 9.10438H2.2738C2.15715 9.10438 2.04528 9.06184 1.9628 8.98613C1.88032 8.91041 1.83398 8.80771 1.83398 8.70063Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.99167 12.7389C8.22496 12.7389 8.44869 12.6539 8.61365 12.5024C8.77862 12.351 8.87129 12.1456 8.87129 11.9314C8.87129 11.7173 8.77862 11.5119 8.61365 11.3604C8.44869 11.209 8.22496 11.1239 7.99167 11.1239C7.75838 11.1239 7.53464 11.209 7.36968 11.3604C7.20472 11.5119 7.11204 11.7173 7.11204 11.9314C7.11204 12.1456 7.20472 12.351 7.36968 12.5024C7.53464 12.6539 7.75838 12.7389 7.99167 12.7389ZM7.99167 13.5464C8.45825 13.5464 8.90572 13.3763 9.23564 13.0734C9.56556 12.7705 9.75091 12.3598 9.75091 11.9314C9.75091 11.5031 9.56556 11.0923 9.23564 10.7894C8.90572 10.4866 8.45825 10.3164 7.99167 10.3164C7.52509 10.3164 7.07762 10.4866 6.74769 10.7894C6.41777 11.0923 6.23242 11.5031 6.23242 11.9314C6.23242 12.3598 6.41777 12.7705 6.74769 13.0734C7.07762 13.3763 7.52509 13.5464 7.99167 13.5464Z"
                      fill="#7D7C7C"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.5515 12.7383H6.67188V16.3721L7.99131 15.7664L9.31074 16.3721V12.7383H8.43112V15.0655L7.99131 14.8636L7.5515 15.0655V12.7383Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">GST</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {organisation?.gstIN}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "2px" }}
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.2992 0.904105C17.2491 0.771095 17.1528 0.663796 17.0304 0.60453C16.908 0.545263 16.7688 0.538592 16.6419 0.585905C16.5149 0.633217 16.41 0.730871 16.3489 0.858549C16.2878 0.986228 16.2752 1.1341 16.3138 1.27141C17.1161 3.7293 15.5236 5.56489 14.3093 6.54804L13.8188 5.79871C13.6538 5.5474 13.2851 5.33843 12.9983 5.33475L10.2451 5.34763C9.90874 5.35846 9.58141 5.46597 9.29768 5.65878L1.18474 11.7225C0.996031 11.864 0.86763 12.0795 0.82765 12.3218C0.787669 12.564 0.839366 12.8133 0.971422 13.015L4.65826 18.6377C4.93462 19.0566 5.37593 19.0059 5.76975 18.7132L13.8827 12.6486C14.1159 12.4727 14.3853 12.0935 14.4803 11.8035L15.3422 8.90835C15.4372 8.6193 15.3794 8.17835 15.2144 7.92704L14.9156 7.47044C16.5461 6.13839 18.2388 3.78453 17.2992 0.904105ZM13.5243 9.51868C13.3748 9.6302 13.2062 9.70923 13.0281 9.75126C12.85 9.7933 12.6658 9.79751 12.4862 9.76365C12.3065 9.7298 12.1349 9.65855 11.9811 9.55396C11.8273 9.44938 11.6943 9.31352 11.5898 9.15414C11.3781 8.83163 11.2951 8.43278 11.3591 8.04514C11.4231 7.6575 11.6287 7.31275 11.9309 7.08657C12.1678 6.90965 12.4506 6.81605 12.7399 6.81886C13.0291 6.82167 13.3103 6.92073 13.5441 7.10222C13.3092 7.25319 13.1477 7.34156 13.1175 7.35537C13.0105 7.40978 12.9239 7.50134 12.8721 7.61504C12.8202 7.72874 12.8061 7.85784 12.8321 7.98118C12.8581 8.10453 12.9226 8.21481 13.0151 8.29395C13.1076 8.37309 13.2226 8.41639 13.3412 8.41677C13.4155 8.41677 13.4915 8.39836 13.5631 8.36246C13.7307 8.27777 13.9103 8.17743 14.0977 8.05868C14.1408 8.3349 14.1099 8.61849 14.0084 8.87678C13.907 9.13508 13.7392 9.35758 13.5243 9.51868Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Brand Name</h4>
                    <p className="text-s capitalize text-secondary-light font-semibold">
                      {organisation?.brandName}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "2px" }}
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.7351 13.7813C9.04696 14.112 9.55075 14.112 9.86262 13.7813L13.2532 10.1863C13.565 9.85565 13.565 9.32149 13.2532 8.98233C13.1792 8.90373 13.0913 8.84137 12.9946 8.79882C12.8978 8.75628 12.7941 8.73438 12.6894 8.73438C12.5847 8.73438 12.481 8.75628 12.3842 8.79882C12.2875 8.84137 12.1996 8.90373 12.1256 8.98233L9.29486 11.9754L8.16734 10.7798C7.85548 10.4492 7.35169 10.4492 7.03183 10.7798C6.71197 11.1105 6.71996 11.6447 7.03183 11.9754L8.7351 13.7813Z"
                      fill="#7D7C7C"
                    />
                    <path
                      d="M15.7476 3.75H4.55244C4.12827 3.75 3.72148 3.92866 3.42155 4.24668C3.12162 4.5647 2.95313 4.99602 2.95312 5.44577V15.6204C2.95313 16.0701 3.12162 16.5014 3.42155 16.8194C3.72148 17.1375 4.12827 17.3161 4.55244 17.3161H15.7476C16.6273 17.3161 17.347 16.553 17.347 15.6204V5.44577C17.347 4.99602 17.1785 4.5647 16.8785 4.24668C16.5786 3.92866 16.1718 3.75 15.7476 3.75ZM15.7476 14.7725C15.7476 15.2388 15.3878 15.6204 14.948 15.6204H5.3521C4.91228 15.6204 4.55244 15.2388 4.55244 14.7725V7.14153H15.7476V14.7725Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Domain</h4>
                    <p className="text-s capitalize text-secondary-light font-semibold">
                      {organisation?.domain}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <svg
                    style={{ marginTop: "4px" }}
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.0504 8.40178C11.0504 7.88013 11.0049 7.37382 10.9441 6.86752H13.5118C13.6333 7.35848 13.7093 7.87246 13.7093 8.40178C13.7093 8.68562 13.6865 8.96179 13.6485 9.23028C14.1727 9.30699 14.6589 9.47576 15.1071 9.72125C15.1831 9.29165 15.2286 8.85439 15.2286 8.40178C15.2286 4.18256 11.8101 0.730469 7.6319 0.730469C3.4309 0.730469 0.0351562 4.18256 0.0351562 8.40178C0.0351562 12.621 3.45369 16.0731 7.6319 16.0731C8.08011 16.0731 8.51312 16.0271 8.93854 15.9503C8.57771 15.2821 8.38959 14.5328 8.39157 13.7717C8.39157 13.5492 8.41436 13.3344 8.44475 13.1196C8.20165 13.6029 7.93577 14.0709 7.6319 14.5081C7.00137 13.5876 6.49239 12.5673 6.18092 11.4703H9.00691C9.46317 10.6697 10.1492 10.0277 10.9745 9.62919C11.02 9.22261 11.0504 8.81603 11.0504 8.40178ZM7.6319 2.28774C8.26243 3.2083 8.77141 4.23626 9.08288 5.33326H6.18092C6.49239 4.23626 7.00137 3.2083 7.6319 2.28774ZM1.75202 9.93604C1.63047 9.44508 1.5545 8.9311 1.5545 8.40178C1.5545 7.87246 1.63047 7.35848 1.75202 6.86752H4.31972C4.25894 7.37382 4.21336 7.88013 4.21336 8.40178C4.21336 8.92343 4.25894 9.42974 4.31972 9.93604H1.75202ZM2.37495 11.4703H4.5932C4.85909 12.4292 5.20094 13.3498 5.65675 14.2013C4.27309 13.7193 3.10792 12.7497 2.37495 11.4703ZM4.5932 5.33326H2.37495C3.10337 4.05001 4.27018 3.07903 5.65675 2.60227C5.20094 3.45378 4.85909 4.37434 4.5932 5.33326ZM9.40954 9.93604H5.85426C5.77829 9.42974 5.73271 8.92343 5.73271 8.40178C5.73271 7.88013 5.77829 7.36615 5.85426 6.86752H9.40954C9.47791 7.36615 9.53108 7.88013 9.53108 8.40178C9.53108 8.92343 9.47791 9.42974 9.40954 9.93604ZM9.59945 2.60227C10.9973 3.08556 12.1596 4.05982 12.8888 5.33326H10.6478C10.41 4.38313 10.058 3.46598 9.59945 2.60227ZM15.6085 12.4292L12 16.0731L9.91092 13.7717L10.7921 12.8818L12 14.1016L14.7273 11.3476L15.6085 12.4292Z"
                      fill="#7D7C7C"
                    />
                  </svg>

                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Website</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {organisation?.website}
                    </p>
                  </div>
                </div>
              </div>
              <div className=" mb-6 hidden lg:flex pl-8 flex-col py-4  items-start bg-primary-extra-light border-primary-dark-20 border-1 border-solid w-263  mr-4">
                <p className="font-semibold text-[18px] text-tertiary-dark mb-5">
                  Primary Contact Person
                </p>
                <div className="flex mb-6">
                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Name</h4>
                    <p className="text-s capitalize text-secondary-light font-semibold">
                      {detail?.fullName}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Email address</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      {detail?.email}
                    </p>
                  </div>
                </div>
                <div className="flex mb-6">
                  <div className="ml-1 flex justify-between flex-col">
                    <h4 className="text-p1 font-semibold">Phone number</h4>
                    <p className="text-s text-secondary-light font-semibold">
                      +91 {detail?.mobile}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex mt-8 lg:mt-0 flex-col px-6 py-4  lg:bg-primary-extra-light border-primary-dark-20 lg:border-1 border-solid lg:w-[calc(100%-280px)] lg:max-w-921 ">
              <h2 className="text-h4  font-semibold text-secondary-dark">
                Order history
              </h2>
              <div className="my-8 lg:my-4">
                {orders?.mySet.map((item) => (
                  <div
                    key={item}
                    className="mb-8 lg:mb-4 p-4 border-1 border-primary-dark-10 bg-primary-white "
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex flex-col items-start">
                        <h3 className=" text-secondary-dark text-p1 lg:text-h4 text-montserrat font-semibold">
                          Order Id: <span className="uppercase">{item}</span>
                        </h3>
                        <p className="text-[14px] lg:text-h5 text-secondary-light">
                          {/* {orders.orderIdGroup[item]} */}
                          {/* {orders.orderIdGroup[item][0].createdAt.slice(0, 10)} 
                          */}
                          {moment(getDate(item)).format("DD MMMM, YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="my-4 flex gap-x-4 overflow-x-scroll overflow-y-hidden">
                      {filterData(item).map((item, index) => {
                        return (
                          <div className=" bg-neutral-0 justify-between rounded-[10px] lg:p-4 flex w-[223px] h-[96px] lg:w-[266px] lg:h-[134px]">
                            <div style={{ background: item?.backgroundColor }} className="flex justify-center items-center  bg-neutral-50 w-[73px] p-2 pr-0 lg:p-0 lg:w-[80px] h-[96px] lg:h-[107px] mr-3 bg-[#A93030] ">
                              {item?.imageCoverFront && (
                                <img
                                  src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/books/${item?.imageCoverFront}`}
                                  alt="Cover photo"
                                  className="h-full object-cover w-[55.5px] h-[77.8px] "
                                />
                              )}
                            </div>
                            <div className="flex flex-col w-[150px] py-[5px] lg:py-0 lg:w-[calc(100%-92px)] justify-between">
                              <p className="text-secondary-light text-medium text-[14px] uppercase">

                              </p>
                              <p className="text-left text-heading-false font-semibold text-[16px] leading-[19px] lg:text-[15px] ">
                                {item?.title}
                              </p>
                              <p className="text-montserrat text-[14px] lg:text-[13px] font-semibold text-secondary-dark">
                                {item.Bauthors?.map(
                                  (auther, index, arr) => <span>{
                                    (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                  }</span>
                                )}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    
                    </div>
                    <div className="text-right mb-2">
                      <button
                        onClick={() => navigate(`order-details=${item}`)}
                        className="underline text-tertiary-dark font-bold"
                      >
                        View More
                      </button>
                    </div>
                  </div>
                ))}
                  {ordersSet?.mySet?.map((item) => (
                        <div
                          key={item}
                          className="mb-8 lg:mb-4 p-4 border-1 border-primary-dark-10 bg-primary-white "
                        >
                          <div className="flex justify-between items-center">
                            <div className="flex flex-col items-start">
                              <h3 className=" text-secondary-dark text-p1 lg:text-h4 text-montserrat font-semibold">
                                Order Id: <span className="uppercase">{item}</span>
                              </h3>
                              <p className="text-[14px] lg:text-h5 text-secondary-light">
                                {moment(getDate(item, 'set')).format("DD MMMM, YYYY")}
                              </p>
                            </div>
                          </div>
                          <div className="my-4 flex gap-x-4 overflow-x-scroll overflow-y-hidden">
                            {filterDataForSet(item).map((item, index) => {
                              return (
                                <div className=" bg-neutral-0 justify-between rounded-[10px] lg:p-4 flex w-[223px] h-[96px] lg:w-[266px] lg:h-[134px]">
                                  <div style={{ background: item.backgroundColor }} className="flex justify-center items-center  bg-neutral-50 w-[73px] p-2 pr-0 lg:p-0 lg:w-[80px] h-[96px] lg:h-[107px] mr-3 bg-[#A93030] ">
                                    {item?.cover && (
                                      <img
                                        src={`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/setCovers/${item?.cover}`}
                                        alt="Cover photo"
                                        className="h-full object-cover w-[55.5px] h-[77.8px] "
                                      />
                                    )}
                                  </div>
                                  <div className="flex flex-col w-[150px] py-[5px] lg:py-0 lg:w-[calc(100%-92px)] justify-between">
                                    <p className="text-secondary-light text-medium text-[14px] uppercase">

                                    </p>
                                    <p className="text-left text-heading-false font-semibold text-[16px] leading-[19px] lg:text-[15px] ">
                                      {item?.title}
                                    </p>
                                    <p className="text-montserrat text-[14px] lg:text-[13px] font-semibold text-secondary-dark">
                                      {/* {item.Bauthors?.map(
                                  (auther, index, arr) => <span>{
                                    (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                  }</span>
                                )} */}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="text-right mb-2">
                            <button
                              onClick={() => navigate(`order-details=${item}`)}
                              className="underline text-tertiary-dark font-bold"
                            >
                              View More
                            </button>
                          </div>
                        </div>
                      ))}
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
      />
    </Page>
  );
}
